import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBerichten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      d="M33 11.25H5v11.38h28z"
    />
    <mask
      id="Berichten_svg__a"
      width={28}
      height={18}
      x={5}
      y={11}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M5 11.25 19 20l14-8.75v17.5H5z"
      />
    </mask>
    <g mask="url(#Berichten_svg__a)">
      <path
        fill="#00A75D"
        d="m-4.49 5.86 12.24 7.07L14.82.68z"
      />
      <path
        fill="#6FBC85"
        d="M7.75 12.93.68 25.18 20 20zM5.86 44.49l7.07-12.24L.68 25.18zM25.18 39.32l7.07-12.25L20 20zM20 20l-7.07 12.25 12.25 7.07z"
      />
      <path
        fill="#00A75D"
        d="m39.32 14.82-7.07 12.25 12.24 7.07z"
      />
      <path
        fill="#6FBC85"
        d="M39.32 14.82 27.07 7.75 20 20z"
      />
      <path
        fill="#00A75D"
        d="M-4.49 5.86.68 25.18l7.07-12.25z"
      />
      <path
        fill="#6FBC85"
        d="m.68 25.18 12.25 7.07L20 20zM20 20l12.25 7.07 7.07-12.25z"
      />
      <path
        fill="#00A75D"
        d="m44.49 34.14-12.24-7.07-7.07 12.25z"
      />
      <path
        fill="#6FBC85"
        d="m20 20 7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <path
      fill="#E63312"
      d="M28.06 35.06a6.94 6.94 0 1 0 0-13.88 6.94 6.94 0 0 0 0 13.88"
    />
    <path
      fill="#fff"
      d="M26.99 23.64h2.12l-.36 5.92h-1.4zm1.06 9.13c-.3 0-.56-.1-.76-.31s-.31-.46-.31-.75.11-.56.32-.77.46-.32.76-.32.55.11.76.32.32.47.32.77-.1.54-.31.75-.46.31-.76.31z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBerichten);

export default ForwardRef;
